module.exports = __webpack_public_path__ + "media/src/images/balloons/iversity-banner-kursseite-black-sale-de-5f0cdce740a744ab4557c06b7e3c9cb9.jpg";